import { Button, Grid, TextField, Typography, styled, useTheme } from "@mui/material";

import Card from "components/Card";
import { ReferralCodeAfterRegister } from "store/api/referral";
import http from "config/http";
import useNotify from "hooks/useNotify";
import { useState } from "react";
import { actionButtonBg } from "utils/helpers/actionButtonBg";

function Introducing() {
  const notify = useNotify();
  const theme = useTheme()

  const [valueRepresentative, setValueRepresentative] = useState("");

  const referralCodeAfterRegister = async () => {
    try {
      await http.post(ReferralCodeAfterRegister, { valueRepresentative });
      notify("کد معرف ثبت شد", "success");
    } catch (error) {
      notify(error?.response?.data?.message, "error");
    }
  };

  return (
    <Grid item xs={12}>
      <Card marginBottom={3}>
        <Typography variant="h5">معرف شما</Typography>

        <Typography variant="h6" color="text.secondary">
          اگر توسط یکی از دوستان خود معرفی شده اید می توانید با وارد کردن کد
          دعوت دوستتان را به عنوان معرف تعیین کنید.
          <br /> توجه داشته باشید که این کد به مدت ۴۸ ساعت پس از ثبت نام شما
          فعال خواهد بود.
        </Typography>

        <Typography variant="h6" color="text.secondary" pb={1} pt={3}>
          کد دعوت دوست شما
        </Typography>

        <Grid container>
          <Grid xs={6} md={3}>
            <RepresentativeField
              variant="outlined"
              value={valueRepresentative}
              onChange={(e) => {
                setValueRepresentative(e.target.value);
              }}
            />
          </Grid>

          <Grid xs={6} md={3} pr={3}>
            <Button
              fullWidth
              onClick={referralCodeAfterRegister}
              color={actionButtonBg(theme)}
            >
              تعیین معرف
            </Button>
          </Grid>
        </Grid>
      </Card>
    </Grid>
  );
}

const RepresentativeField = styled(TextField)(() => ({
  ".MuiInputBase-input": {
    minHeight: "50px",
    padding: "0 14px",
  },
}));

export default Introducing;
